import { render, staticRenderFns } from "./descStatistics.vue?vue&type=template&id=37b747fc&scoped=true&"
import script from "./descStatistics.vue?vue&type=script&lang=js&"
export * from "./descStatistics.vue?vue&type=script&lang=js&"
import style0 from "./descStatistics.vue?vue&type=style&index=0&id=37b747fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b747fc",
  null
  
)

export default component.exports